import {useEffect, useState} from 'react';
import LayoutComponent from "../components/LayoutComponent";
import {useApi} from "../provider/ApiProvider";
import {DownloadOutlined} from "@ant-design/icons";
import {Button, Popconfirm} from "antd";
import TableComponent from "../components/TableComponent";
import moment from "moment";

export default function Logs() {
    const columns = [
        {
            title: 'User ID',
            dataIndex: 'UserId',
            key: 'UserId',
            width: 100
        },

        {
            title: 'Mesaj',
            dataIndex: 'message',
            key: 'message',
            width: 350,
        },
        {
            title: 'Tarih',
            width: 250,
            render: (record) => <span>{moment(record.updatedAt).format('DD.MM.YYY HH:mm')}</span>

        },
        {
            title: 'Detay',
            dataIndex: 'logDetail',
            key: 'logDetail',
        },
    ];

    const {api} = useApi();
    const [logs, setLoags] = useState({totalCount: 0, items: []});
    useEffect(() => {
        load()
    },[])

    async function load(){
        await api.get('/logRouter/log/all').then(resp => {
                setLoags({totalCount: resp.totalCount, items: resp.data});
        }).catch(err => {
            console.log('errr');
        })
    }

    async function getFile(){
        await api.get('/logRouter/log/getFile').then(resp => {
            let a = document.createElement('a');
            a.target="_blank";
            a.href=resp.data;
            a.click();
        })
    }

    return (
        <LayoutComponent title={"Log Listesi"} links={
            [
                {
                    title: 'Loglar',
                    url: '/'
                },

            ]}
        >
            <div style={{marginBottom: '10px', display: 'flex', justifyContent: 'end'}}>
                <Button icon={<DownloadOutlined />} onClick={() => {getFile()}} type="primary">Log Dosyası</Button>
            </div>
            <TableComponent
                columns={columns}
                data={logs}
            />
        </LayoutComponent>
    )
}
